import "../styles/carousel.scss";
import React, { useEffect, useState } from "react";
import '../styles/projects.scss';
import { projects } from "../constants/constants";
import "../styles/projectSummary.scss"
import { useSelector, useDispatch } from "react-redux";
import { PreviousNext } from "../constants/constants";
import { gitHubRepositoryLabel } from "../constants/constants";
import { webPageLabel } from "../constants/constants";

const ProjectSummary = (props) => {


    /********************Defining Hooks****************************/


    //Defining image folder name inside public folder
    const imageFolder = "projects"/*props.imageFolder;*/

    const storeCurrentProject = state => state.carouselCurrentProject;
    const currentProject = useSelector(storeCurrentProject)

    const storeCurrentImage = state => state.carouselCurrentImage;
    const currentImage = useSelector(storeCurrentImage)

    const storeNumberOfImages = state => state.carouselNbOfImages;
    const numberOfImages = useSelector (storeNumberOfImages);

    const dispatch = useDispatch()

    //Setting up a hook on current language
    const storeCurrentLanguage = state => state.language;
    const currentLanguage = useSelector(storeCurrentLanguage);


    useEffect(() => {

    }, []);

    const projectTechnologies = projects[props.projectIndex].techs.map(tech => {
        return <img className = "project-summary__tech-container__tech" src = {"./images/skills/"+tech+".png"}></img>
    } )

    let nextProject = null
    if (currentProject === projects.length - 1) {
        nextProject = 0
    } else {
        nextProject = currentProject + 1
    }

    const currentRepo = () => {
        if (projects[currentProject].repo && projects[currentProject].webPage) {
            return (
            <div className = "project-summary__links-container">
                <div className = "project-summary__links-container__label">{gitHubRepositoryLabel[currentLanguage]}</div>
                <a href = {projects[currentProject].repo}> <i class="project-summary__links-container__link fab fa-github"></i></a>
                <div className = "project-summary__links-container__label">{webPageLabel[currentLanguage]}</div>
                <a href = {projects[currentProject].webPage}> <i class="project-summary__links-container__link fas fa-eye"></i></a>
            </div>
            )
        }
        else if (!projects[currentProject].repo && projects[currentProject].webPage) {
            return (
                <div className = "project-summary__links-container">
                <div className = "project-summary__links-container__label">{webPageLabel[currentLanguage]}</div>
                <a href = {projects[currentProject].webPage}> <i class="project-summary__links-container__link fas fa-globe"></i></a>
            </div>
            )
        } else {
            return (
                <div className = "project-summary__links-container">
                <div className = "project-summary__links-container__label">{gitHubRepositoryLabel[currentLanguage]}</div>
                <a href = {projects[currentProject].repo}> <i class="project-summary__links-container__link fab fa-github"></i></a>
            </div>
            )
        }     
    }

    
    return (

        
        <div className = "project-summary">
            <div className = "project-summary__browse project-summary__browse--left" onClick = {(e) => {
                if (currentProject === 0) {
                    dispatch({type : 'project/set/currentProject', payload : projects.length -1 })
                } else {
                    dispatch({type : 'project/set/currentProject', payload : currentProject -1 })
                }
                
            }}><i class="fas fa-angle-double-left"></i>{/*<div>{PreviousNext['previous'][currentLanguage]}</div>*/}</div>
            <div className = "project-summary__title" >{projects[props.projectIndex].name}</div>
            <div className = "project-summary__description">{projects[props.projectIndex].description[currentLanguage]}</div> 
            <div className = "project-summary__browse project-summary__browse--right" onClick = {(e) => {
                if (currentProject === projects.length - 1) {
                    dispatch({type : 'project/set/currentProject', payload : 0 })
                } else {
                    dispatch({type : 'project/set/currentProject', payload : currentProject + 1 })
                }
                
            }}>{/*<div>{PreviousNext['next'][currentLanguage]}</div>*/}<i class="fas fa-angle-double-right"></i></div>
            <div className = "project-summary__tech-container" >
                   {projectTechnologies}
            </div>
                {currentRepo()}
            
        </div>
        
        
        

    )
    
}

export default ProjectSummary
